import {
  FILTER_EVENT_JSON,
  scrubSensitiveData,
} from '@findigs/helpers/src/integrations/sentry.shared';
import { useLocation, useMatches } from '@remix-run/react';
import * as Sentry from '@sentry/remix';
import { useEffect } from 'react';
import type { WindowEnv } from '~/root';

const ENV = (window as any).ENV as WindowEnv;

let initialized = false;
export const initSentry = () => {
  if (initialized) return;

  //TODO: DOMO-842 All the clean-up
  Sentry.init({
    environment: ENV.BUILD_ENV,
    dsn: ENV.SENTRY_DSN,
    release: ENV.SENTRY_RELEASE,
    tracesSampleRate: parseFloat(ENV.SENTRY_TRACES_SAMPLE_RATE),
    replaysSessionSampleRate: parseFloat(ENV.SENTRY_REPLAY_SAMPLE_RATE),
    replaysOnErrorSampleRate: 1,
    denyUrls: ['localhost'],

    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      } as any),
      Sentry.captureConsoleIntegration({ levels: ['error'] }),
    ],
    beforeSend(event) {
      try {
        const json = JSON.stringify(event);
        if (FILTER_EVENT_JSON.test(json)) return null;
      } catch {
        // filtering failed so let it be sent to be safe
      }

      return scrubSensitiveData(event);
    },
    beforeSendTransaction: scrubSensitiveData,
  });

  initialized = true;
};
